import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CompressIcon(props: IconProps) {
    return <Icon {...props} iconKey={"compress"}/>
}
